var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavigationAndActionFailLarge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-445.000000, -912.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Navigation-and-action/Fail/Large",
    transform: "translate(445.000000, 912.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16,0 C24.837,0 32,7.163 32,16 C32,24.836 24.837,32 16,32 C7.163,32 0,24.836 0,16 C0,7.163 7.163,0 16,0 Z M16,2 C8.268,2 2,8.268 2,16 C2,23.731 8.268,30 16,30 C23.732,30 30,23.731 30,16 C30,8.268 23.732,2 16,2 Z M16,21.5 C17.104,21.5 18,22.396 18,23.5 C18,24.604 17.104,25.5 16,25.5 C14.895,25.5 14,24.604 14,23.5 C14,22.396 14.895,21.5 16,21.5 Z M18,5 L17,19 L15,19 L14,9 C14,6.85793939 15.6840992,5.10892929 17.8003715,5.00489568 L18,5 Z",
    id: 236
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationAndActionFailLarge);
export default __webpack_public_path__ + "static/media/navigation-and-action-fail-large.c7cbe352.svg";
export { ForwardRef as ReactComponent };